import { modelHelperModule } from './model-helper';
import { ROLES_ARRAY } from '../utils/role-utils';
import { checkPrivilege } from '../utils/privilege-utils';

export const teamMemberModelModule = angular
  .module('Q.models.team-member', [modelHelperModule])

  .factory('TeamMember', function (ModelHelper) {
    const roleIds = ROLES_ARRAY.map((role) => role.id);
    const findRoleById = (id) =>
      ROLES_ARRAY.filter((role) => role.id === id)[0];

    function isRole(currentRoleId, minimumRoleId) {
      let currentRole = findRoleById(currentRoleId),
        minimumRole = findRoleById(minimumRoleId);
      if (!currentRole || !minimumRole) return false;
      return currentRole.level >= minimumRole.level;
    }

    const TeamMember = ModelHelper.defineResource({
      name: 'TeamMember',
      endpoint: 'team_members',

      serialize: ModelHelper.serializeWithUiPrefs,
      deserialize: ModelHelper.deserializeWithUiPrefs,

      relations: {
        hasMany: {
          Assessment: {
            foreignKey: 'teamMemberId',
            foreignField: 'teamMember',
          },
        },
        belongsTo: {
          Team: {
            localKey: 'teamId',
            localField: 'team',
          },
        },
      },

      computed: {
        nameOrEmail: /* @ngInject */ function (name, email) {
          return name || email;
        },
        assignable: /* @ngInject */ function (state, role) {
          return state !== 'inactive' && role !== 'demo';
        },
      },

      methods: {
        loginType: 'team_member',
        publishedFirstJob() {
          return !this.team || this.team.publishedFirstJob;
        },
        hasRole(role) {
          return !role || isRole(this.mockRole || this.role, role);
        },
        hasPrivilege(privilege, value) {
          return checkPrivilege(this, privilege, value);
        },
        isActive() {
          return this.state === 'active';
        },
        isInactive() {
          return this.state === 'inactive';
        },
        isPremiumRole() {
          return this.role === 'owner' || this.role === 'inviter';
        },
        isRestrictedRole() {
          return (
            this.role === 'reviewer' ||
            this.role === 'viewer' ||
            this.role === 'blind_reviewer'
          );
        },
        isBlindReviewer() {
          return !this.privileges.viewPiiInfo;
        },
        isDemo() {
          return this.role === 'demo';
        },
        hasFeature(feature, featureLevels) {
          if (this.features && this.features[feature] !== undefined) {
            return !!(this.features && this.features[feature]);
          }
          if (this.team) {
            return this.team.hasFeature(feature, featureLevels);
          }
          return false;
        },
        getRoleName() {
          let role = findRoleById(this.role);
          return role && role.name;
        },
        stateName() {
          return this.getEnum('state');
        },
        toString() {
          return this.nameOrEmail;
        },
        setPrivilege(privilege, value, options) {
          const privileges = angular.copy(this.privileges);
          privileges[privilege] = value;
          return TeamMember.updatePrivileges(
            this,
            { data: privileges },
            options,
          );
        },
        setPrivileges(privileges, options) {
          return TeamMember.updatePrivileges(
            this,
            { data: privileges },
            options,
          );
        },
      },

      staticMethods: {
        getUsableRoles(user) {
          return roleIds.filter(user.hasRole.bind(user)).map(findRoleById);
        },
      },

      meta: {
        actionEndpoints: {
          resendInvite: { method: 'PUT', track: true },
          activate: { method: 'PUT', track: true },
          deactivate: { method: 'PUT', track: true },
          updatePrivileges: {
            method: 'PUT',
            segment: 'privileges',
            responseHandler(res, TeamMember, instance) {
              return TeamMember.refresh(instance);
            },
          },
        },
        saveExcludes: ['team'],
      },
    });

    return TeamMember;
  });
